const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  optionValueSelectionChange: 'option-value-selection-change',
  variantChange: 'variant-change',
  cartError: 'cart-error',
};

/* Stillsoft: load the gift script from the same assets folder.
   Bump SS_GIFT_VERSION whenever assets/ss-cap-gift.js changes, or browsers keep the cached copy. */
(function () {
  var SS_GIFT_VERSION = '28';
  var current = document.currentScript;
  if (!current || !current.src) return;
  var gift = document.createElement('script');
  gift.src = current.src.replace('constants.js', 'ss-cap-gift.js') + (current.src.indexOf('?') === -1 ? '?' : '&') + 'ssv=' + SS_GIFT_VERSION;
  gift.defer = true;
  document.head.appendChild(gift);
})();